class PressSlider {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.wrapper = document.getElementById("press-slider-" + sectionId);

    if (!this.wrapper) {
      console.warn("Press slider wrapper not found for section:", sectionId);
      return;
    }

    this.settings = window.pressSectionSettings?.[sectionId] || {};
    this.swiperMain = null;
    this.swiperThumbs = null;

    this.init();
  }

  init() {
    this.initSwipers();
  }

  initSwipers() {
    const mainElement = this.wrapper.querySelector(".press-swiper-main");
    const thumbsElement = this.wrapper.querySelector(".press-swiper-thumbs");

    if (!mainElement || !thumbsElement) {
      console.warn("Swiper elements not found");
      return;
    }

    this.swiperThumbs = new Swiper(thumbsElement, {
      slidesPerView: "auto",
      spaceBetween: 0,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      centeredSlides: false,
      freeMode: {
        enabled: true,
        sticky: false,
      },
    });

    const mainConfig = {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 600,
      thumbs: {
        swiper: this.swiperThumbs,
      },
    };

    if (this.settings.enableAutoRotate) {
      mainConfig.autoplay = {
        delay: this.settings.autoRotateSpeed,
        disableOnInteraction: false,
      };

      if (this.settings.pauseOnHover) {
        mainConfig.autoplay.pauseOnMouseEnter = true;
      }
    }

    this.swiperMain = new Swiper(mainElement, mainConfig);
  }

  destroy() {
    if (this.swiperMain) {
      this.swiperMain.destroy(true, true);
      this.swiperMain = null;
    }
    if (this.swiperThumbs) {
      this.swiperThumbs.destroy(true, true);
      this.swiperThumbs = null;
    }
  }
}

class PressSliderManager {
  constructor() {
    this.sliders = new Map();
    this.init();
  }

  init() {
    if (typeof Swiper === "undefined") {
      document.addEventListener("DOMContentLoaded", () =>
        this.initAllSliders(),
      );
    } else {
      this.initAllSliders();
    }
  }

  initAllSliders() {
    if (typeof window.pressSectionSettings === "undefined") {
      return;
    }

    Object.keys(window.pressSectionSettings).forEach((sectionId) => {
      this.initSlider(sectionId);
    });
  }

  initSlider(sectionId) {
    if (!this.sliders.has(sectionId)) {
      const slider = new PressSlider(sectionId);
      this.sliders.set(sectionId, slider);
    }
  }

  destroySlider(sectionId) {
    const slider = this.sliders.get(sectionId);
    if (slider) {
      slider.destroy();
      this.sliders.delete(sectionId);
    }
  }

  destroyAllSliders() {
    this.sliders.forEach((slider) => slider.destroy());
    this.sliders.clear();
  }
}

window.pressSliderManager = new PressSliderManager();

if (Shopify?.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    const sectionId = event.detail.sectionId;
    if (window.pressSectionSettings?.[sectionId]) {
      window.pressSliderManager.initSlider(sectionId);
    }
  });

  document.addEventListener("shopify:section:unload", (event) => {
    window.pressSliderManager.destroySlider(event.detail.sectionId);
  });
}

class ComparisonTableEqualizer {
  constructor() {
    this.SELECTOR =
      ".comparison-table-carousel slideshow-slide " +
      ".spacing-style.slide__content " +
      ".group-block.superglow-cell-sizes " +
      ".group-block__media-wrapper + " +
      ".group-block-content.layout-panel-flex--column > *:nth-child(4)";

    this.resizeTimer = undefined;
    this.init();
  }

  init() {
    document.addEventListener("DOMContentLoaded", () => this.equalizeHeights());
    window.addEventListener("load", () => this.equalizeHeights());

    window.addEventListener("resize", () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.equalizeHeights(), 150);
    });
  }

  equalizeHeights() {
    const els = [...document.querySelectorAll(this.SELECTOR)];
    if (!els.length) return;

    els.forEach((el) => el.style.removeProperty("--cell-height"));

    const maxH = Math.max(...els.map((el) => el.offsetHeight));

    if (maxH > 0) {
      els.forEach((el) => el.style.setProperty("--cell-height", `${maxH}px`));
    }
  }

  destroy() {
    clearTimeout(this.resizeTimer);
  }
}

new ComparisonTableEqualizer();

/* Before/After Sliders */

const sliders = document.querySelectorAll(".before-after-slider");

sliders.forEach((container) => {
  const input = container.querySelector(".before_after--slider");

  if (input) {
    input.addEventListener("input", (e) => {
      container.style.setProperty("--position", `${e.target.value}%`);
    });
  }
});
